import is from '@sindresorhus/is';

const setInputValue = (input: HTMLInputElement, nextValue: string): void => {
    Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set?.call(input, nextValue);
    input.dispatchEvent(new Event('input', { bubbles: true }));
};

const restoreCaret = (input: HTMLInputElement, caret: number): void => {
    requestAnimationFrame(() => {
        input.focus();
        input.setSelectionRange(caret, caret);
    });
};

export const getInputSelectionRange = (input: HTMLInputElement): { readonly start: number; readonly end: number } => {
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    return start <= end ? { start, end } : { start: end, end: start };
};

export const hasInputSelection = (input: HTMLInputElement): boolean => {
    const { start, end } = getInputSelectionRange(input);
    return start !== end;
};

export const removeInputSelection = (input: HTMLInputElement): void => {
    const { start, end } = getInputSelectionRange(input);
    setInputValue(input, input.value.slice(0, start) + input.value.slice(end));
    restoreCaret(input, start);
};

export const insertIntoInput = (input: HTMLInputElement, text: string): void => {
    if (is.emptyString(text)) return;
    const { start, end } = getInputSelectionRange(input);
    setInputValue(input, input.value.slice(0, start) + text + input.value.slice(end));
    restoreCaret(input, start + text.length);
};
